module.exports = __webpack_public_path__ + "static/media/Ezreal_0.fc683afd.png";